import { mutationOptions } from '@tanstack/react-query'
import { keys } from '../queries/keys'
import {
  createRbacRole,
  replaceRbacRoleAdmins,
  replaceRbacRolePermissions,
  replaceRbacRoleV2Permissions,
  updateRbacRole,
} from './rbac.mutations'

export const createRbacRoleOptions = () =>
  mutationOptions({
    mutationFn: createRbacRole,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

export const updateRbacRoleOptions = () =>
  mutationOptions({
    mutationFn: updateRbacRole,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

export const replaceRbacRolePermissionsOptions = () =>
  mutationOptions({
    mutationFn: replaceRbacRolePermissions,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

export const replaceRbacRoleV2PermissionsOptions = () =>
  mutationOptions({
    mutationFn: replaceRbacRoleV2Permissions,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

export const replaceRbacRoleAdminsOptions = () =>
  mutationOptions({
    mutationFn: replaceRbacRoleAdmins,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })
